/* vim: set ts=2 sw=2 sts=2 et: */

/**
 * Copyright (c) 2001-present X-Cart Holdings LLC. All rights reserved.
 * See https://www.x-cart.com/license-agreement.html for license details.
 */

const uiCommentedData = document.getElementById('ui-commented-data');
const conf = xcart.getCommentedData(uiCommentedData, 'appConfig');

module.exports = conf;



//////////////////
// WEBPACK FOOTER
// ./config/app-config.js
// module id = D3Sj
// module chunks = 1